import { adapter } from "@hg/adapt-sdk"
import { getSDKReadyFunc } from "@hg/hg-web-sdk"

adapter.init()
export { adapter }

const ETL_OPTION = {
    domain: "arknights",
    sub_domain: "activity",
    pageProperties: {
        language: document.documentElement.lang,
        source: adapter.source.from || "",
        share_type: adapter.share.type || "",
        share_by: adapter.share.by || "",
    },
}

export const sdkReady = getSDKReadyFunc(__SDK_SRC, {
    etl: ETL_OPTION,
})

if (__SDK_HOST) {
    sdkReady((sdk) => {
        sdk.hostConfig.u8Server.setHost(__SDK_HOST)
        sdk.hostConfig.hgServer.setHost(__SDK_HOST)
    })
}

export const analyticsEvent = async (
    eventName: string,
    params: Record<string, string>
) => {
    const sdk = await sdkReady()
    const analytics = sdk.Analytics.get()
    analytics?.event(eventName, params)
}

export async function collect(
    event: string,
    properties: Record<string, unknown>
) {
    const sdk = await sdkReady()
    sdk.ETL.event(event, properties)
}
